module.exports = __webpack_public_path__ + "f3053782bb113df6a3d51ea277237e13.svg";